export default __webpack_public_path__ + "static/media/page-not-found.049354d3.png";